import {Component, Input, OnDestroy, OnInit} from '@angular/core'
import {MenuService} from './menu.service'
import {MlVsService} from '../ml-vendor.search/ml.vs.service'
import {Subscription} from 'rxjs'
import {AuthService} from '../../services/auth.service'
import {environment} from '../../../../environments/environment'
import {MenuCfg} from '../../interfaces/aside-menu'
import {VendorSearch} from '../../interfaces/vendor-details'

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    standalone: false
})
export class MenuComponent implements OnInit, OnDestroy {

  @Input() isCollapsed: boolean
  menu: MenuCfg[] = []
  private subs = new Subscription()
  private selectedVendor: VendorSearch | undefined

  constructor(
    public menuService: MenuService,
    private VS: MlVsService,
    private Auth: AuthService
  ) { }

  ngOnInit(): void {
    this.subs.add(this.VS.selectedVendor.subscribe(vendor => {
      this.selectedVendor = vendor
      this.refreshMenu()
    }))
    this.subs.add(this.menuService.menuChanges.subscribe(() => {
      this.refreshMenu()
    }))
  }

  private refreshMenu(): void {
    if (!this.Auth.isAuthenticated()) {
      return
    }
    this.menu = this.buildMenu(this.menuService.menu, this.selectedVendor)
  }

  private buildMenu(items: MenuCfg[], data: VendorSearch | undefined): MenuCfg[] {
    if (data !== undefined) {
      if (environment.isHotel(data.vendor)) {
        return items
          .filter(i => i.title !== 'Schedules')
          .map(i => ({...i, disabled: false}))
      }
      return items
        .filter(i => i.title !== 'Hotel Schedules')
        .map(i => ({...i, disabled: false}))
    }

    const hiddenWhenNoVendor = [
      'Availability',
      'Schedules',
      'Hotel Schedules',
      'Allotments',
      'Rates',
      'Rate Levels',
      'Manage Products'
    ]
    return items
      .filter(i => hiddenWhenNoVendor.indexOf(i.title) === -1)
      .map(i => ({...i, disabled: false}))
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
  }

}
